import './ColorPicker.css';

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}

const PRESET_COLORS: Record<string, string> = {
  primary: '#3a57e8',
  success: '#1aa053',
  danger: '#c03221',
  warning: '#f16a1b',
  info: '#079aa2',
  secondary: '#6c757d',
  dark: '#212529',
};

const normalizeHex = (hex: string): string => {
  const normalized = hex.toLowerCase();
  // 3-digit → 6-digit: #f80 → #ff8800
  if (/^#[0-9a-f]{3}$/.test(normalized)) {
    return '#' + normalized[1].repeat(2) + normalized[2].repeat(2) + normalized[3].repeat(2);
  }
  return normalized;
};

export function ColorPicker({ value, onChange }: ColorPickerProps) {
  return (
    <div className="color-picker">
      {Object.entries(PRESET_COLORS).map(([key, color]) => (
        <button
          key={key}
          type="button"
          data-testid={`color-picker-${key}`}
          className={`color-picker__swatch${normalizeHex(value) === color ? ' color-picker__swatch--selected' : ''}`}
          style={{ backgroundColor: color }}
          onClick={() => onChange(color)}
        />
      ))}
      <input
        type="color"
        data-testid="color-picker-custom-input"
        className="color-picker__custom-input"
        value={normalizeHex(value)}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
